import React from 'react';
import StaticContentPage from '../components/StaticContentPage';
import { Shield, Info, UserCheck, Scale, FileText, RefreshCw, Lock, AlertTriangle, Globe } from 'lucide-react';

const TermsSection = ({ icon: Icon, title, children }) => (
  <div className="mb-12">
    <div className="flex items-center gap-3 mb-6">
      <div className="p-2 rounded-xl bg-brand-indigo/10 text-brand-indigo">
        <Icon size={20} />
      </div>
      <h2 className="text-2xl font-bold text-gray-900 tracking-tight">{title}</h2>
    </div>
    <div className="text-gray-600 leading-relaxed space-y-4 ml-1">
      {children}
    </div>
  </div>
);

const TermsOfService = () => {
  return (
    <StaticContentPage title="Terms of Service" lastUpdated="May 14, 2026">
      <div className="max-w-3xl mb-12">
        <p className="text-xl font-medium text-gray-700 leading-relaxed mb-6">
          Welcome to Chooziq.
        </p>
        <p className="text-gray-600 leading-relaxed">
          These Terms of Service (“Terms”) govern your access to and use of the Chooziq platform, website, communities, live rooms, and related services (collectively, the “Services”). By accessing or using Chooziq, you agree to be bound by these Terms.
        </p>
      </div>

      <TermsSection icon={Info} title="1. About Chooziq">
        <p>Chooziq is a realtime interaction and collaborative engagement platform designed for communities, events, educational environments, organizations, workshops, webinars, conferences, and collaborative experiences.</p>
        <p>The Services enable users to host live sessions, create and manage communities, and participate in realtime discussions and engagement.</p>
      </TermsSection>

      <TermsSection icon={UserCheck} title="2. Eligibility">
        <p>By using the Services, you represent that you have the legal capacity to enter into these Terms and are authorized to use the Services under applicable laws. If using on behalf of an organization, you represent authority to bind that organization.</p>
      </TermsSection>

      <TermsSection icon={Lock} title="3. User Accounts">
        <p>Users may be required to create an account for certain features. You are responsible for maintaining credential confidentiality and for all activity occurring under your account.</p>
      </TermsSection>

      <TermsSection icon={Scale} title="4. Acceptable Use">
        <p>You agree to use the Services in compliance with these Terms, laws, community guidelines, and platform policies. Prohibited activities include unlawful activity, harassment, spam, and interfering with platform operations.</p>
      </TermsSection>

      <TermsSection icon={FileText} title="5. User Content">
        <p>You retain ownership of your content but grant Chooziq a license to host, store, and display such content solely for operating the Services. You are responsible for the content you submit.</p>
      </TermsSection>

      <TermsSection icon={RefreshCw} title="6. Public and Persistent Content">
        <p>Certain interactions may remain accessible after live sessions end, including discussions, Q&A, and brainstorm boards. Visibility depends on community and privacy settings.</p>
      </TermsSection>

      <TermsSection icon={Shield} title="7. Communities and Moderation">
        <p>Communities may establish additional rules. Chooziq reserves the right to review content, remove material, or moderate activity to maintain platform integrity.</p>
      </TermsSection>

      <TermsSection icon={Globe} title="8. Intellectual Property">
        <p>The Chooziq platform, design, and branding are owned by Chooziq and protected by intellectual property laws. Unauthorized copying or modification is prohibited.</p>
      </TermsSection>

      <TermsSection icon={AlertTriangle} title="12. Disclaimers">
        <p>The Services are provided “as is” without warranties of any kind. Use of the Services is at your own risk.</p>
      </TermsSection>

      <TermsSection icon={Lock} title="13. Limitation of Liability">
        <p>To the fullest extent permitted by law, Chooziq shall not be liable for any indirect or consequential damages arising from the use of the Services.</p>
      </TermsSection>

      <div className="bg-gray-50 p-10 rounded-[40px] border border-gray-100 mt-16 text-center">
        <h3 className="text-2xl font-bold text-gray-900 mb-4">Contact Information</h3>
        <p className="text-gray-600 mb-6">If you have questions regarding these Terms of Service, please contact us.</p>
        <div className="flex flex-col items-center gap-2">
          <a href="mailto:legal@chooziq.com" className="text-lg font-bold text-brand-indigo hover:underline">legal@chooziq.com</a>
        </div>
      </div>
    </StaticContentPage>
  );
};

export default TermsOfService;
